import {findPayoutBankInfo} from "../Util/queries";
import {constructPayoutBankInfo} from "../Factory/factory";
import {PAYOUT_BANK_INFO} from "../Reducers/payoutBankInfoReducer";

export const getPayoutInfo = () => async dispatch => {
    try {
        const response = await findPayoutBankInfo();

        const payoutBankInfoObj = constructPayoutBankInfo(response.data.stripeAccountId, response.data.actorId,
            response.data.actorType, response.data.connectStatus, response.data.stripeEmail,
            response.data.accountNumber, response.data.routingNumber, response.data.accountHolder,
            response.data.ipAddress
        );

        dispatch({
            type: PAYOUT_BANK_INFO,
            payload: payoutBankInfoObj
        });
    } catch (e) {
        console.error(e);
        dispatch({
            type: PAYOUT_BANK_INFO,
            payload: null
        });
    }
}
